import React from 'react'
import { useTranslate } from './TranslationText'
import HorseCard from './HorseCard';
import EahsForm from './EahsForm';

export default function StudBookTab({ Data, handlePageChange, page, totalCount, take, renderPagination, noBackGround }) {
    const { translate } = useTranslate();
    return (
        <>
            {Data.length > 0 &&
                Data.map((item, i) => (
                    <HorseCard isArabicClass={true} item={item} i={i} />
                ))}

            {Data.length === 0 && (
                <div className='col-12 '>
                    <div className='bg-white w-100 border-15 p-main p-3 text-center'>
                        {translate("web.nodataFound", "No data Found!")}
                    </div>
                </div>
            )}
            <div className="col-lg-12 col-md-12 col-sm-12 rtl  text-center">
                {page !== 1 && (
                    <React.Fragment>
                        <span
                            className="btn btn-dark mx-2 fw-bold"
                            onClick={() =>
                                handlePageChange(page - 1)
                            }
                        >
                            {"<"}
                        </span>
                    </React.Fragment>
                )}
                <span className='spanbtnmargin'> 
                    {renderPagination()}
                </span>

                {Data.length > 0 &&
                    page !==
                    Math.ceil(
                        totalCount / take
                    ) && (
                        <React.Fragment>
                            <span
                                className="btn btn-dark mx-2 fw-bold"
                                onClick={() =>
                                    handlePageChange(page + 1)
                                }
                            >
                                {">"}
                            </span>


                        </React.Fragment>
                    )}
            </div>
        </>
    )
}
